import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dealer-notifications',
    imports: [],
    templateUrl: './dealer-notifications.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dealer-notifications.component.css'
})
export class DealerNotificationsComponent {

}
